module.exports = __webpack_public_path__ + "45a38dee690080900cf1e210e21f7407.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/script/svganimations/svg/BUSINESS_SVG.svg
 ** module id = 17
 ** module chunks = 0
 **/